import { render, staticRenderFns } from "./ItWomen.vue?vue&type=template&id=d5911a22&scoped=true&"
import script from "./ItWomen.vue?vue&type=script&lang=js&"
export * from "./ItWomen.vue?vue&type=script&lang=js&"
import style0 from "./ItWomen.vue?vue&type=style&index=0&id=d5911a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5911a22",
  null
  
)

export default component.exports